// Vibration for hits, level-ups and bosses. Best effort: browsers without navigator.vibrate (iPhone, desktop) skip it.
let enabled = true;

export function setVibration(on: boolean): void {
  enabled = on;
}

export function vibrate(pattern: number | number[]): void {
  if (enabled) navigator.vibrate?.(pattern);
}
